<template>
  <el-radio-group v-model="radioValue" class="switch-button">
    <el-radio
      v-for="(item, index) in options"
      border
      :key="index"
      :label="item.value"
    >
      {{ item.label || $t(item.labelI18nKey) }}
    </el-radio>
  </el-radio-group>
</template>

<script>

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      required: true
    },
    options: {
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    radioValue: {
      get () {
        return this.checked
      },
      set (val) {
        this.$emit('change', val)
      }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss">
.switch-button {
  .el-radio {
    margin-right: 15px;
    position: relative;
    border-radius: 2px;

    &.is-checked::after {
      display: block;
      width: 0;
      height: 0;
      border: 15px solid #0c8cf6;
      border-top-color: transparent;
      border-left-color: transparent;
      border-bottom-right-radius: 2px;
      content: '\e6da';
      font-family: element-icons;
      font-weight: bold;
      color: #ffffff;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .el-radio__input {
      display: none;
    }
  }
}
</style>
